var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-b-5" },
    [
      _c(
        "v-table",
        {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.rttReferences,
            "current-page": _vm.currentPage,
            "page-size": 10,
            "hide-sort-icons": true
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function({ displayData }) {
                return _c(
                  "tbody",
                  {},
                  _vm._l(displayData, function(row) {
                    return _c("tr", { key: row.id }, [
                      _c("td", [_vm._v(_vm._s(row.type))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "table-ellipsis__name linked-name",
                            attrs: {
                              rel: "noopener",
                              target: "_blank",
                              href: row.link
                            }
                          },
                          [
                            _c("span", { attrs: { title: row.name } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(row.name) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n          " + _vm._s(row.id) + "\n        ")
                      ])
                    ])
                  }),
                  0
                )
              }
            }
          ])
        },
        [
          _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
            _c(
              "tr",
              [
                _c(
                  "v-th",
                  {
                    attrs: {
                      "custom-sort": _vm.typeSort,
                      "default-sort": "asc"
                    }
                  },
                  [_vm._v("\n          Type\n        ")]
                ),
                _vm._v(" "),
                _c("v-th", { attrs: { "sort-key": "name" } }, [
                  _vm._v("\n          Name\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "RTT_REFERENCES_TABLE_ID",
                        expression: "'RTT_REFERENCES_TABLE_ID'"
                      }
                    ]
                  },
                  [_vm._v("\n          Id\n        ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.getRingTreeTargetReferencesStatus.status === "pending"
        ? _c(
            "div",
            { staticClass: "well well-sm text-center" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "RTT_REFERENCES_LOADING",
                    expression: "'RTT_REFERENCES_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getRingTreeTargetReferencesStatus.status === "success" &&
      _vm.rttReferences.length === 0
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "RTT_REFERENCES_EMPTY",
                expression: "'RTT_REFERENCES_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }